<form [formGroup]="hostelForm" (ngSubmit)="onSubmit()" novalidate>
    <div class="flex items-center justify-center dialog-header">
        {{type}} Hostel Category
        <div class="absolute right-2">
            <button (click)="handleCloseDialog()" class="outline-none p-5">
                <i class="pi pi-times"></i>
            </button>
        </div>
    </div>

    <div class="dialog-content" style="margin-top: -15px;">
            <!-- Hostel Name -->
            <div class="field">
                <label class="requiredValue">Hostel Name</label>
                <input pInputText formControlName="hostel_name" placeholder="Enter Hostel Name" />
                <small *ngIf="hostelForm.get('hostel_name')?.invalid && isSubmitted" class="p-error">
                    Hostel Name is required
                </small>
            </div>

            <!-- Room Type and Capacity -->
            <div class="grid grid-cols-1 md:grid-cols-2 md:gap-2">
                <div class="field">
                    <label class="requiredValue">Room Type</label>
                    <p-select [options]="roomTypeOptions" formControlName="room_type" placeholder="Select Room Type"></p-select>
                    <small *ngIf="hostelForm.get('room_type')?.invalid && isSubmitted" class="p-error">
                        Room Type is required
                    </small>
                </div>

                <div class="field">
                    <label class="requiredValue">Capacity</label>
                    <input pInputText formControlName="capacity" placeholder="Enter Capacity" type="number" />
                    <small *ngIf="hostelForm.get('capacity')?.invalid && isSubmitted" class="p-error">
                        Capacity is required and must be greater than 0
                    </small>
                </div>
            </div>

            <!-- Fee Amount and Currency -->
            <div class="grid grid-cols-1 md:grid-cols-2 md:gap-2">
                <div class="field">
                    <label class="requiredValue">Fee Amount</label>
                    <input pInputText formControlName="fee_amount" placeholder="Enter Fee Amount" type="number" />
                    <small *ngIf="hostelForm.get('fee_amount')?.invalid && isSubmitted" class="p-error">
                        Fee Amount is required
                    </small>
                </div>

                <div class="field">
                    <label class="requiredValue">Currency</label>
                    <p-select [options]="currencyOptions" formControlName="currency" placeholder="Select Currency"></p-select>
                    <small *ngIf="hostelForm.get('currency')?.invalid && isSubmitted" class="p-error">
                        Currency is required
                    </small>
                </div>
            </div>

            <!-- Facilities -->
            <div class="field" formGroupName="facilities">
                <label>Facilities</label>
                <div class="grid grid-cols-2 md:grid-cols-4 gap-2 mt-2">
                    <div *ngFor="let facility of facilitiesOptions" class="flex align-items-center">
                        <p-checkbox [formControlName]="facility.key" [inputId]="facility.key" binary="true"></p-checkbox>
                        <label [for]="facility.key" class="ml-2 text-sm">{{ facility.label }}</label>
                    </div>
                </div>
            </div>

            <!-- Status -->
            <div class="field">
                <label class="requiredValue">Status</label>
                <p-select [options]="statusOptions" formControlName="status" placeholder="Select Status"></p-select>
                <small *ngIf="hostelForm.get('status')?.invalid && isSubmitted" class="p-error">
                    Status is required
                </small>
            </div>

            <!-- Action buttons -->
            <div class="flex justify-end gap-2 mt-8">
                <p-button label="Cancel" severity="danger" variant="outlined" (click)="handleCloseDialog()"></p-button>
                <p-button label="Save" icon="pi pi-save" [loading]="btnLoading" [disabled]="btnLoading"
                    (click)="onSubmit()"></p-button>
            </div>
    </div>
</form>
